/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'book-manage': {
    width: 128,
    height: 128,
    viewBox: '0 0 1047 1024',
    data: '<path pid="0" d="M550.245 0h-157.22c-28.814 0-52.39 23.576-52.39 52.39v890.88c0 28.816 23.576 52.391 52.39 52.391h157.22c28.815 0 52.39-23.575 52.39-52.39V52.39C602.636 23.576 579.06 0 550.246 0zM209.61 209.61H52.415C23.6 209.61.024 233.186.024 262.001v681.27c0 28.815 23.576 52.39 52.39 52.39H209.61c28.815 0 52.391-23.575 52.391-52.39V262.025c0-28.815-23.576-52.39-52.39-52.39zm835.846 710.085L927.553 248.927c-5.239-28.815-31.434-47.151-60.273-41.912l-154.6 26.195c-28.815 5.24-47.151 31.434-41.912 60.25L788.67 964.226c5.239 28.815 31.434 47.152 60.249 41.913l154.6-26.196c28.815-5.239 47.152-31.434 41.913-60.25z"/>'
  }
})
